import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import styles from "./Login.module.css";
import AuthContext from "../store/AuthCtx";
import { ClipLoader } from "react-spinners";
import logo from "../assets/logo.svg";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import { toast } from "react-toastify";

function LoginPage() {
  const AuthCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const emailRef = useRef();
  const passwordRef = useRef();

  useEffect(
    () => {
      if (AuthCtx.userToken && AuthCtx.isLoggedIn) {
        navigate("/dashboard/rates");
      }
    },
    // eslint-disable-next-line
    []
  );

  const submitHandler = async (event) => {
    event.preventDefault();
    const email = emailRef.current.value.trim();
    const password = passwordRef.current.value.trim();
    setIsLoading(true);
    try {
      let data = await api.post("users/login", { email, password });
      AuthCtx.login(data.data.token, data.data.user);
      navigate("/dashboard/rates");
      setIsLoading(false);
    } catch (err) {
      toast.error("Invalid Cridentials");
    }
    setIsLoading(false);
  };
  return (
    <Fragment>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <img src={logo} alt="logo" style={{ margin: "auto" }} width={200} />
          <h2 className={styles.loginHeading}>Login</h2>
          <form onSubmit={submitHandler}>
            <input
              ref={emailRef}
              type="email"
              autoComplete="email"
              placeholder="Enter Email"
              required
            />
            <input
              ref={passwordRef}
              type="password"
              placeholder="Enter Password"
              autoComplete="current-password"
              required
            />
            <button>
              {" "}
              <ClipLoader loading={isLoading} color="#9CAFAA" size={10} /> Sign
              In
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
}

export default LoginPage;
